import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-full border border-foreground/10 px-3 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-negative/20 dark:aria-invalid:ring-negative/40 aria-invalid:border-negative transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary-dark text-primary-foreground [a&]:hover:bg-primary/90',
        purple:
          'border-transparent bg-purple-500/50 text-foreground [a&]:hover:bg-purple/90',
        accent:
          'border-transparent bg-accent text-accent-foreground [a&]:hover:bg-accent/90',
        negative:
          'border-transparent bg-negative text-white [a&]:hover:bg-negative/90 focus-visible:ring-negative/20 dark:focus-visible:ring-negative/40 dark:bg-negative/60',
        outline:
          'text-foreground [a&]:hover:bg-primary [a&]:hover:text-primary-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span';

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
